// 対象主催者ID管理
export const TARGET_ORGANIZER_IDS = [
  // 1, // ローカルとテスト環境のテスト主催者
  2210, // テスト22年4月以降契約プロモーター（本番環境のテスト主催者）
  2013, // 婚活NANA
  1570 // LINK×LINK(リンクリンク)
]

export const isFemalePageTarget = organizerId => {
  return TARGET_ORGANIZER_IDS.includes(Number(organizerId))
}

// 開発環境での確認用
export const getFemalePageTargets = () => {
  return TARGET_ORGANIZER_IDS
}
